var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#36354C",
    d: "M12 11.734a1.811 1.811 0 1 0 0-3.623 1.811 1.811 0 0 0 0 3.623"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#36354C",
    fillRule: "evenodd",
    d: "M12 5.045a5.31 5.31 0 0 0-5.311 5.32v.002c0 2.412 1.367 4.571 2.84 6.183a18 18 0 0 0 2.476 2.235 17.092 17.092 0 0 0 2.468-2.197c1.467-1.594 2.837-3.754 2.837-6.221h.773l-.773-.002A5.31 5.31 0 0 0 12 5.045m6.856 5.322a6.856 6.856 0 1 0-13.712 0c0 2.986 1.674 5.507 3.243 7.225a19.3 19.3 0 0 0 2.902 2.583q.133.095.207.145l.058.039.016.01.005.004.002.001.423-.647-.422.648c.253.165.58.167.835.005L12 19.727l.414.653.002-.002.005-.003.016-.01.058-.039q.076-.048.208-.142a18.638 18.638 0 0 0 2.906-2.55c1.575-1.709 3.246-4.23 3.247-7.267",
    clipRule: "evenodd"
  })));
};
export default SvgLocation;